import { useCallback, useState } from 'react';

/** Ширина, ниже которой блок данных о диалоге считается скрытым, px. */
const HIDDEN_BLOCK_WIDTH = 1;

/**
 * Видимость блока данных о диалоге в разделённой раскладке.
 *
 * Панели раскладки не объявлены схлопывающимися: скрытый блок — это сведённая границей
 * к нулю ширина, а не состояние схлопывания у библиотеки, поэтому признак считается
 * по фактическому размеру панели.
 */
export const useDialogDataVisibility = () => {
  const [isDataHidden, setIsDataHidden] = useState(false);

  const handleDataResize = useCallback((size: { inPixels: number }) => {
    setIsDataHidden(size.inPixels < HIDDEN_BLOCK_WIDTH);
  }, []);

  return { isDataHidden, handleDataResize };
};
